/**
 * Normalizes a MIME type to a canonical form.
 * Handles known aliases and normalizes case/whitespace.
 */
function normalizeMimeType(mimeType: string): string {
  const normalized = mimeType.trim().toLowerCase();

  if (
    normalized === 'application/x-mpegurl' ||
    normalized === 'video/hls' ||
    normalized === 'application/vnd.apple.mpegurl'
  ) {
    return 'application/x-mpegURL';
  }

  return mimeType.trim();
}

/**
 * Resolves the mime type for a playable source.
 * Video.js uses this to pick the correct playback pipeline; forcing HLS for a
 * DASH `.mpd` will make VHS try to parse it as a playlist and emit warnings.
 */
export function resolveVideoMimeType({
  declaredType,
  src,
}: {
  declaredType?: string;
  src?: string;
}): string {
  if (declaredType) return normalizeMimeType(declaredType);
  if (!src) return 'application/x-mpegURL';

  const pathname = (() => {
    try {
      return new URL(src).pathname;
    } catch {
      return src;
    }
  })();

  const extension = pathname
    .split('?')[0]
    ?.split('#')[0]
    ?.split('.')
    .pop()
    ?.toLowerCase();

  if (extension === 'mpd') return 'application/dash+xml';
  if (extension === 'm3u8') return 'application/x-mpegURL';
  if (extension === 'mp4') return 'video/mp4';
  if (extension === 'm4v') return 'video/mp4';
  if (extension === 'mov') return 'video/mp4';

  return 'application/x-mpegURL';
}
